import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { LoginPage } from '@/pages/LoginPage';
import { HomePage } from '@/pages/HomePage';
import { AccessDeniedPage } from '@/pages/AccessDeniedPage';
import { StoreOpeningPage } from '@/pages/store-opening/StoreOpeningPage';
import { STORAGE_KEY_SESSION_TOKEN } from '@/config';

function RequireSession({ children }: { children: React.ReactNode }) {
  const token = localStorage.getItem(STORAGE_KEY_SESSION_TOKEN);
  if (!token) return <Navigate to="/login" replace />;
  return <>{children}</>;
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/access-denied" element={<AccessDeniedPage />} />
        <Route
          path="/"
          element={
            <RequireSession>
              <HomePage />
            </RequireSession>
          }
        />
        <Route
          path="/store-opening"
          element={
            <RequireSession>
              <StoreOpeningPage />
            </RequireSession>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
